import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAdminNotifications() {
  try {
    yield put(actions.addAdminNotificationsLoading(true));
    const result = yield call(api.getAdminNotifications);
    yield put(actions.getAdminNotificationsSuccess(result.data));
  } catch (error) {
    yield put(actions.getAdminNotificationsFail(error));
    toast.error(error?.response?.data?.message || "Failed to load notifications");
  } finally {
    yield put(actions.addAdminNotificationsLoading(false));
  }
}

export default function* AdminNotificationsSaga() {
  yield takeLatest(Types.GET_ADMIN_NOTIFICATIONS_REQUEST, getAdminNotifications);
}

